var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.snackbar && _vm.snackbar.type && _vm.snackbar.message)?_c('v-alert',{staticClass:"mt-2 mb-n2",attrs:{"type":_vm.snackbar.type,"dismissible":""}},[_vm._v(_vm._s(_vm.message))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }